/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, station: NonNullable<unknown> }} Camera_Station_Detach_ConfirmInputs */

const vi_camera_station_detach_confirm = /** @type {(inputs: Camera_Station_Detach_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gỡ camera "${i?.name}" khỏi trạm ${i?.station}? Camera vẫn còn trong Danh sách camera.`)
};

/**

* @param {Camera_Station_Detach_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_detach_confirm = /** @type {((inputs: Camera_Station_Detach_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_Detach_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_detach_confirm(inputs)
});